import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { DeleteFlowVersionsRequest } from '../../flow/serverApi/requests/DeleteFlowVersionsRequest';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import { GetFlowVersionsRequest, GetFlowVersionsResult } from '../serverApi/requests/GetFlowVersionsRequest';
import { FlowRevision } from '../serverApi/types/FlowRevision';

export class FlowRevisionsResource {
  private fetcher = new WebClientListResourceFetcher(GetFlowVersionsRequest, (result: GetFlowVersionsResult) => result.versions);

  public all(): ResourceQuery<FlowRevision> {
    return new ResourceQuery(this.fetcher);
  }

  public del = (id: string): Promise<IResult> => {
    return WebHttpClientWithErrorToastInstance.sendRequestsAndDelay(
      RequestHelper.buildRequests([id], (idsBlock) => new DeleteFlowVersionsRequest(idsBlock)),
      ResultHelper.combineResults);
  }
}

export const FlowRevisions = new FlowRevisionsResource();
